import React from 'react';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {Step, Stepper, StepLabel, StepContent} from 'material-ui/Stepper';
import Tab from '../../components/tab';
import GA from '../../helpers/ga';

const PAGE_VIEW_NAME = '/dashboard/features/more';

export class EmailUsPage extends React.Component {
	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	render () {
		const paneHeight = this.props.containerHeight - 70;

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='More'
				subHeaderText='Contact us to request for new features'
			>
				<Stepper activeStep={0} orientation='vertical'>
					<Step>
						<StepLabel style={{fontSize: 16}}>Contact Us!</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0'}}>
								We value our customer opinion and ideas. If you have any feature idea or feature request, please contact our support team at
								<span style={{color: '#007ec0', fontWeight: 500}}> support@chated.io</span>.
							</p>
						</StepContent>
					</Step>
				</Stepper>
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {};
}

export function mapsDispatchToProps ( dispatch ) {
	return {};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(EmailUsPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-features-more-page/email-us-page.js